/**
 * Reasons Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";

// States
const state = {
    reasons: [],
    reason: {}
};

// Getters
const getters = {
    reasons: state => {
        return state.reasons
    },

    reason: state => {
        return state.reason
    }
};

// Actions
const actions = {
    getReasons(context, payload) {
        function successCallback(response) {
            context.commit('getReasonsHandler', { reasons: response.data.motifs });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Reason.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getReason(context, payload) {
        function successCallback(response) {
            context.commit('getReasonHandler', { reason: response.data.motif });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Reason.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createReason(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'reasons' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Reason.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createConsultationReason(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            context.commit('getGeneralConsultationHandler', { consultation: response.data.consultation });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }



        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.Reason.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createHospitalisationReason(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.back();
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Reason.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateReason(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.back();
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Reason.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteReason(context, payload) {
        function successCallback(response) {
            context.commit('deleteReasonHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Reason.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteConsultationReason(context, payload) {
        function successCallback(response) {
            // context.commit('deleteConsultationReasonHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getGeneralConsultationHandler', { consultation: response.data.consultation });
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        makeApiRequest(payload.args, apiModel.Consultation.General.Reason.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteHospitalisationReason(context, payload) {
        function successCallback(response) {
            context.commit('deleteHospitalisationReasonHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Hospitalisation.Reason.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    }
};

// Mutations
const mutations = {
    getReasonsHandler(state, { reasons }) {
        // Update reasons state
        state.reasons = reasons;
    },

    getReasonHandler(state, { reason }) {
        // Update reason state
        state.reason = reason;
    },

    deleteReasonHandler(state, { index, successMessage }) {
        let i = state.reasons.findIndex(reason => reason.slug === index);

        if (~i) {
            state.reasons.splice(i, 1);

            router.push({ name: 'reasons' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },

    deleteConsultationReasonHandler(state, { index, successMessage }) {
        let i = state.reasons.findIndex(reason => reason.slug === index);

        if (~i) {
            state.reasons.splice(i, 1);

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}